/** Where a login still waiting for its CG leader's link lands instead of MyGiving. */
export const MY_GIVING_WAITING_FOR_LINK_PATH = '/my-giving/waiting-for-link';
